import React, {useMemo} from "react";
// LayoutContext
import {useHtmlClassService} from "../../../_metronic/layout/_core/MetronicLayout";
// Import Layout components
import {
HeaderMobile,
//Aside, //--> menu
Header,
Footer,
ScrollTop,
LayoutInit
} from "../../components";
// Import containers
import {
    SubHeaderContainer
} from "../../containers"

export function Layout({ children }) {
    const uiService = useHtmlClassService();
    // Layout settings (cssClasses/cssAttributes)
    const layoutProps = useMemo(() => {
        return {
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true)
        };
    }, [uiService]);

    return (
        <>

            {/*begin::Main*/}
            <HeaderMobile/>
            <div className="d-flex flex-column flex-root">
                {/*begin::Page*/}
                <div className="d-flex flex-row flex-column-fluid page">
                    {/* <Aside/> //--> menu */}
                    {/*begin::Wrapper*/}
                    <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                        <Header/>
                        {/*begin::Content*/}
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            <SubHeaderContainer/>
                            {/*begin::Entry*/}
                            <div className="d-flex flex-column-fluid">
                                {/*begin::Container*/}
                                <div className={layoutProps.contentContainerClasses}>
                                    {children}
                                </div>
                                {/*end::Container*/}
                            </div>
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        <Footer/>
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
            <ScrollTop/>
            {/*end::Main*/}
            <LayoutInit />
        </>
    );
}
